import * as swcHelpers from '@swc/helpers';
import { lensAddOnStepBase } from '../shared/lens-add-on.js';
import { lensAddOnVariantStep } from '../shared/lens-add-on-variant.js';
import { lensPackageStepBase } from '../shared/lens-package.js';
import { lensTypeStepBase } from '../shared/lens-type.js';
import { lensTypeVariantStep } from '../shared/lens-type-variant.js';
import { prescriptionEntrySelectionStepBase } from '../shared/prescription-entry-selection.js';
import { prescriptionFormStepBase } from '../shared/prescription-form.js';
import { prescriptionUploadStepBase } from '../shared/prescription-upload.js';
import { prescriptionValidationStepBase } from '../shared/prescription-validation.js';
import { reviewStepBase } from '../shared/review.js';

const labelKeys = {
    lensType: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.lensType',
        title: 'products.rxsun.lensType.title',
        description: 'products.rxsun.lensType.description'
    },
    lensTypeVariant: {
        title: 'products.rxsun.lensTypeVariant.title',
        description: 'products.rxsun.lensTypeVariant.description'
    },
    prescription: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.prescription',
        title: 'products.rxsun.prescription.title',
        description: 'products.rxsun.prescription.description'
    },
    prescriptionEntrySelection: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.prescription',
        title: 'products.rxsun.prescriptionEntry.title',
        description: 'products.rxsun.prescriptionEntry.description'
    },
    prescriptionUpload: {
        title: 'products.rxsun.prescriptionUpload.title',
        description: 'products.rxsun.prescriptionUpload.description'
    },
    prescriptionForm: {
        title: 'products.rxsun.prescriptionForm.title',
        description: 'products.rxsun.prescriptionForm.description'
    },
    prescriptionValidation: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.prescriptionValidation',
        title: 'products.rxsun.validationStep.title',
        description: 'products.rxsun.validationStep.description'
    },
    lensPackage: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.lensPackage',
        title: 'products.rxsun.lensPackage.title',
        description: 'products.rxsun.lensPackage.description'
    },
    lensAddOn: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.lensAddOn',
        title: 'products.rxsun.lensAddOn.title',
        description: 'products.rxsun.lensAddOn.description'
    },
    lensAddOnVariant: {
        title: 'products.rxsun.lensAddOnVariant.title',
        description: 'products.rxsun.lensAddOnVariant.description'
    },
    review: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.review',
        title: 'products.rxsun.review.title',
        description: 'products.rxsun.review.description'
    }
};
const stepsMap = {
    lensType: swcHelpers.objectSpread({}, lensTypeStepBase, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys.lensType, {
            alternativeCta: 'products.rxsun.lensType.selectVariant'
        })
    }),
    lensTypeVariant: swcHelpers.objectSpread({}, lensTypeVariantStep, {
        labelKeys: labelKeys.lensTypeVariant
    }),
    prescription: swcHelpers.objectSpread({}, prescriptionEntrySelectionStepBase, {
        labelKeys: labelKeys.prescriptionEntrySelection
    }),
    prescriptionUpload: swcHelpers.objectSpread({}, prescriptionUploadStepBase, {
        labelKeys: labelKeys.prescriptionUpload
    }),
    prescriptionForm: swcHelpers.objectSpread({}, prescriptionFormStepBase, {
        labelKeys: labelKeys.prescriptionForm
    }),
    prescriptionValidation: swcHelpers.objectSpread({}, prescriptionValidationStepBase, {
        labelKeys: labelKeys.prescriptionValidation
    }),
    lensPackage: swcHelpers.objectSpread({}, lensPackageStepBase, {
        labelKeys: labelKeys.lensPackage
    }),
    lensAddOn: swcHelpers.objectSpread({}, lensAddOnStepBase, {
        labelKeys: labelKeys.lensAddOn
    }),
    lensAddOnVariant: swcHelpers.objectSpread({}, lensAddOnVariantStep, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys.lensAddOnVariant, {
            alternativeCta: 'products.rxsun.lensAddOn.selectVariant'
        })
    }),
    review: swcHelpers.objectSpread({}, reviewStepBase, {
        labelKeys: labelKeys.review
    })
};

export { stepsMap };
//# sourceMappingURL=index.js.map
